{
  "schemaVersion": "cogo.verified-design-libraries.manifest.v1",
  "generatedBy": "scripts/build-verified-design-libraries-manifest.ts",
  "generatedFrom": {
    "vaultRegistry": "docs/figma-sources/registry.v1.json",
    "receiptsRoot": "docs/figma-sources/receipts",
    "admissionRoot": "docs/figma-sources/admission-v2"
  },
  "libraries": [
    {
      "sourceId": "cogo.verified-design-library.v1",
      "sourceKind": "operator-owned-figma",
      "rightsRoute": "operator-rights-receipt-required",
      "generationEligible": false,
      "snapshot": {
        "status": "native-bytes-collected-awaiting-rights"
      },
      "admission": {
        "stage": "no-admission-evidence",
        "designations": [],
        "qualityAdmissionReceipts": [],
        "reuseReceipts": [],
        "localEvaluationRights": [],
        "confirmationDecisions": [],
        "agreedGrant": null,
        "agreedLicense": null
      }
    },
    {
      "sourceId": "figma-community.carbon-v11",
      "sourceKind": "community-figma",
      "rightsRoute": "derived-spec-observation-only",
      "generationEligible": false,
      "snapshot": {
        "status": "bytes-verified-local-evaluation",
        "sha256": "1c9a4f45828396bbd6221c63d39fb0787114ec2cc644b8603d298e9064cac36c",
        "byteLength": 17463683,
        "importReceiptPath": "docs/figma-sources/receipts/figma-community.carbon-v11/native-fig-import.v1.json"
      },
      "admission": {
        "stage": "library-reuse-admitted",
        "designations": [
          {
            "designationId": "designation.carbon-v11.foundation-component.v1",
            "path": "docs/figma-sources/admission-v2/figma-community.carbon-v11/designation.foundation-component.v1.json"
          },
          {
            "designationId": "designation.carbon-v11.button.v1",
            "path": "docs/figma-sources/admission-v2/figma-community.carbon-v11/designation.v1.json"
          }
        ],
        "qualityAdmissionReceipts": [
          {
            "receiptId": "fq-receipt.carbon-v11.foundation-component.v2",
            "schemaVersion": "cogo.figma-quality-admission-receipt.v2",
            "path": "docs/figma-sources/receipts/figma-community.carbon-v11/fq-admission-receipt.foundation-component.v2.json"
          },
          {
            "receiptId": "fq-receipt.carbon-v11.p1-families.v1",
            "schemaVersion": "cogo.figma-quality-admission-receipt.v2",
            "path": "docs/figma-sources/receipts/figma-community.carbon-v11/fq-admission-receipt.p1-families.v1.json"
          }
        ],
        "reuseReceipts": [
          {
            "receiptId": "reuse.carbon-v11.foundation-component.v2",
            "schemaVersion": "cogo.library-reuse-admission-receipt.v2",
            "path": "docs/figma-sources/receipts/figma-community.carbon-v11/rights/LibraryReuseAdmissionReceipt.foundation-component.v2.json",
            "grant": {
              "localEvaluation": true,
              "ontologyExtraction": true,
              "packDerivation": true,
              "derivativePublication": false,
              "rawRedistribution": false,
              "upstreamWriteback": false
            },
            "license": {
              "status": "verified",
              "spdx": "CC-BY-4.0"
            }
          },
          {
            "receiptId": "reuse.carbon-v11.p1-families.v1",
            "schemaVersion": "cogo.library-reuse-admission-receipt.v2",
            "path": "docs/figma-sources/receipts/figma-community.carbon-v11/rights/LibraryReuseAdmissionReceipt.p1-families.v1.json",
            "grant": {
              "localEvaluation": true,
              "ontologyExtraction": true,
              "packDerivation": true,
              "derivativePublication": false,
              "rawRedistribution": false,
              "upstreamWriteback": false
            },
            "license": {
              "status": "verified",
              "spdx": "CC-BY-4.0"
            }
          }
        ],
        "localEvaluationRights": [
          {
            "receiptId": "local-rights.carbon-v11.v1",
            "schemaVersion": "cogo.local-evaluation-rights-receipt.v2",
            "path": "docs/figma-sources/receipts/figma-community.carbon-v11/rights/LocalEvaluationRightsReceipt.v2.json",
            "permittedOperations": [
              "headless-parse",
              "local-preview-render"
            ],
            "assetEgressAllowed": false,
            "networkExfiltrationAllowed": false,
            "license": {
              "status": "verified",
              "spdx": "CC-BY-4.0"
            }
          }
        ],
        "confirmationDecisions": [
          {
            "decisionId": "fq-decision.carbon-v11.foundation-component.v2",
            "decision": "approved",
            "decidedAt": "2026-07-29T00:02:18.000Z",
            "path": "docs/figma-sources/receipts/figma-community.carbon-v11/fq-confirmation-decision.foundation-component.v2.json"
          },
          {
            "decisionId": "fq-decision.carbon-v11.p1-families.v1",
            "decision": "approved",
            "decidedAt": "2026-07-29T09:30:00.000Z",
            "path": "docs/figma-sources/receipts/figma-community.carbon-v11/fq-confirmation-decision.p1-families.v1.json"
          }
        ],
        "agreedGrant": {
          "localEvaluation": true,
          "ontologyExtraction": true,
          "packDerivation": true,
          "derivativePublication": false,
          "rawRedistribution": false,
          "upstreamWriteback": false
        },
        "agreedLicense": {
          "status": "verified",
          "spdx": "CC-BY-4.0"
        }
      },
      "communityResourceId": "1157761560874207208",
      "communityUrl": "https://www.figma.com/files/team/971314428972739725/resources/community/file/1157761560874207208"
    },
    {
      "sourceId": "figma-community.material-3",
      "sourceKind": "community-figma",
      "rightsRoute": "derived-spec-observation-only",
      "generationEligible": false,
      "snapshot": {
        "status": "bytes-verified-awaiting-rights",
        "sha256": "d224c237f870c74c8c456ffd365c95145272e3cd5d457a463b6d59af6cbfaa53",
        "byteLength": 57368646
      },
      "admission": {
        "stage": "admission-blocked",
        "designations": [
          {
            "designationId": "designation.material3.foundation-building-blocks.v1",
            "path": "docs/figma-sources/admission-v2/figma-community.material-3/designation.v1.json"
          }
        ],
        "qualityAdmissionReceipts": [],
        "reuseReceipts": [],
        "localEvaluationRights": [],
        "confirmationDecisions": [],
        "agreedGrant": null,
        "agreedLicense": null,
        "gateReport": {
          "path": "docs/figma-sources/admission-v2/figma-community.material-3/admission-readiness.v1.json",
          "status": "blocked",
          "nextRequiredGate": "local-evaluation-rights",
          "effectiveCapabilities": {
            "localEvaluation": false,
            "ontologyExtraction": false,
            "packDerivation": false,
            "derivativePublication": false,
            "rawRedistribution": false,
            "upstreamWriteback": false
          }
        },
        "blockedAtGate": "local-evaluation-rights"
      }
    },
    {
      "sourceId": "figma-community.flowbite-free",
      "sourceKind": "community-figma",
      "rightsRoute": "derived-spec-observation-only",
      "generationEligible": false,
      "snapshot": {
        "status": "bytes-verified-awaiting-rights",
        "sha256": "147564c22a961d69a2ed2615901275489bb2c6746737b098904f66884f2f0f17",
        "byteLength": 28538195
      },
      "admission": {
        "stage": "admission-blocked",
        "designations": [
          {
            "designationId": "designation.flowbite.foundation-feedback-forms.v1",
            "path": "docs/figma-sources/admission-v2/figma-community.flowbite-free/designation.v1.json"
          }
        ],
        "qualityAdmissionReceipts": [],
        "reuseReceipts": [],
        "localEvaluationRights": [],
        "confirmationDecisions": [],
        "agreedGrant": null,
        "agreedLicense": null,
        "gateReport": {
          "path": "docs/figma-sources/admission-v2/figma-community.flowbite-free/admission-readiness.v1.json",
          "status": "blocked",
          "nextRequiredGate": "local-evaluation-rights",
          "effectiveCapabilities": {
            "localEvaluation": false,
            "ontologyExtraction": false,
            "packDerivation": false,
            "derivativePublication": false,
            "rawRedistribution": false,
            "upstreamWriteback": false
          }
        },
        "blockedAtGate": "local-evaluation-rights"
      }
    },
    {
      "sourceId": "figma-community.simple-design-system",
      "sourceKind": "community-figma",
      "rightsRoute": "reference-only",
      "generationEligible": false,
      "snapshot": {
        "status": "not-collected"
      },
      "admission": {
        "stage": "no-admission-evidence",
        "designations": [],
        "qualityAdmissionReceipts": [],
        "reuseReceipts": [],
        "localEvaluationRights": [],
        "confirmationDecisions": [],
        "agreedGrant": null,
        "agreedLicense": null
      }
    }
  ]
}
